'use strict';

module.exports = require('./elements.json');
